import { useNavigate } from "react-router-dom";

import { useTranslation } from "@/core/i18n";
import Cart from "atoms/icon/icons/cart.svg";
import { IconButton } from "atoms/icon-button/IconButton";
import { useShopFlowPath } from "modules/standaloneProducts/standaloneProductsPaths";

import { usePendingCartCount } from "./pendingCart";

type Props = {
  platformId: string | undefined;
};

/**
 * The cart icon shown while browsing anonymously: the badge counts the local
 * pending cart, which `/cart` renders without prices until the visitor logs in.
 */
export const AnonymousCartButton = ({ platformId }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const flowPath = useShopFlowPath();
  const pendingCartCount = usePendingCartCount(platformId);

  return (
    <div className="relative">
      <IconButton
        svg={Cart}
        size="small"
        style="iconOnly"
        aria-label={t("anonymousBrowsing.viewCart")}
        onClick={() => navigate(flowPath("/cart"))}
      />
      {pendingCartCount > 0 && (
        <div className="absolute right-0 top-0 inline-flex h-5 w-5 items-center justify-center rounded-full border-2 border-white bg-brand-color text-xs font-bold text-white">
          {pendingCartCount}
        </div>
      )}
    </div>
  );
};
